import { SVGProps } from 'react';

function DownArrowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width}
      height={props.height}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M1.767.742 5 3.975 8.233.742a.83.83 0 1 1 1.175 1.175L5.583 5.742a.83.83 0 0 1-1.175 0L.583 1.917a.83.83 0 0 1 0-1.175.848.848 0 0 1 1.184 0Z'
        fill={props.fill}
      />
    </svg>
  );
}

export default DownArrowIcon;
